export const facilityAppDownloadBannerVisibilityLocalStorageKey =
  "facilityAppDownloadBannerVisible";
export const facilityAppStoreUrl = "https://clipboardfacility.page.link/open-hcf-app";
